module.exports = __webpack_public_path__ + "media/packs/static/fonts/SFProDisplay/semibold-6adcdcfb722a234ddab4730fd069a09e.woff2";